import {
  COMMON,
  type CommonProps,
  type FlexProps,
  type LayoutProps,
  TYPOGRAPHY,
  type TypographyProps,
} from '#app/theme/constants.js';
import { FLEX, LAYOUT } from '#app/theme/index.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { styled } from 'styled-components';

export type TextProps = CommonProps &
  FlexProps &
  LayoutProps &
  SXProps &
  TypographyProps;

export const Text = styled.p<TextProps>`
  ${COMMON}
  ${FLEX}
  ${LAYOUT}
  ${TYPOGRAPHY}
  ${sx}
`;
